import type { PricingPlan } from 'Services/ProductManagement/Features/Product/productSlice'
import {
  createContext,
  type Dispatch,
  type FC,
  type ReactNode,
  type SetStateAction,
  useMemo,
  useState
} from 'react'

interface TariffContextType {
  selectedTariffId: string
  setSelectedTariffId: Dispatch<SetStateAction<string>>
  copiedPricingPlan: PricingPlan[] | undefined
  setCopiedPricingPlan: Dispatch<SetStateAction<PricingPlan[] | undefined>>
}

const TariffContext = createContext<TariffContextType>({
  selectedTariffId: '',
  // biome-ignore lint/suspicious/noEmptyBlockStatements: This is a default value for the context
  setSelectedTariffId: () => {},
  copiedPricingPlan: undefined,
  // biome-ignore lint/suspicious/noEmptyBlockStatements: This is a default value for the context
  setCopiedPricingPlan: () => {}
})

interface TariffProviderProps {
  children: ReactNode
}

const TariffProvider: FC<TariffProviderProps> = ({ children }) => {
  const [selectedTariffId, setSelectedTariffId] = useState<string>('')
  const [copiedPricingPlan, setCopiedPricingPlan] = useState<PricingPlan[]>()

  const tariffProviderValues = useMemo(
    () => ({
      selectedTariffId,
      setSelectedTariffId,
      copiedPricingPlan,
      setCopiedPricingPlan
    }),
    [selectedTariffId, copiedPricingPlan]
  )

  return <TariffContext.Provider value={tariffProviderValues}>{children}</TariffContext.Provider>
}

export { TariffContext, TariffProvider }
